<template>
  <div class="p-field p-col-12 p-md-12">
    <ConfirmDialog />
    <DataTable
      :value="userLiteraryAbilities"
      class="p-datatable-sm p-datatable-responsive"
    >
      <template #header>
        <div class="p-fluid p-formgrid p-grid">
          <div style="text-align: left" class="p-field p-md-10">
            <h5>Habilitações Literárias</h5>
          </div>
          <div style="text-align: right" class="p-field p-md-2">
            <Button
              v-if="inEditing"
              icon="pi pi-plus"
              class="p-button-primary p-button-sm"
              @click="addItem"
            />
          </div>
        </div>
      </template>
      <Column field="educationLevel" header="Nivel de Escolaridade"></Column>
      <Column
        field="qualificationsLevel"
        header="Nível de Qualificações"
      ></Column>
      <Column field="course" header="Curso"></Column>
      <Column>
        <template #body="slotProps">
          <Button
            v-if="!inEditing"
            icon="pi pi-eye"
            class="p-button-rounded p-button-success p-button-text"
            @click="editItem(slotProps.data)"
          />
          <Button
            v-if="inEditing"
            icon="pi pi-pencil"
            class="p-button-rounded p-button-success p-button-text"
            @click="editItem(slotProps.data)"
          />
          <Button
            v-if="inEditing"
            icon="pi pi-trash"
            class="p-button-sm p-button-rounded p-button-danger p-button-text"
            @click="removeItem(slotProps.data)"
          />
        </template>
      </Column>
    </DataTable>

    <Dialog
      :visible.sync="showForm"
      :style="{ width: $isMobile() ? '100vw' : '50vw' }"
      :header="'Adicionar Habilitação Literária'"
      :modal="true"
      :contentStyle="{ overflow: 'hide' }"
    >
      <form
        name="literaryAbilitiesForm"
        class="p-col-12"
        @submit.prevent="saveItem"
        style="min-height: 35vh"
      >
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-mt-3 p-field p-col-12 p-md-4">
            <span class="p-float-label">
              <Dropdown
                name="educationLevel"
                v-model="formValues.educationLevel"
                :options="educationLevelList"
                v-bind:class="[
                  { 'p-error': errors.has('educationLevel') },
                  'form-control',
                ]"
                :disabled="!inEditing"
                v-validate="'required'"
              />
              <label for="educationLevel">Nivel de Escolaridade</label>
            </span>
            <small
              v-if="errors.has('educationLevel')"
              class="p-error"
              role="alert"
              >Nível de Escolaridade é obrigatório</small
            >
          </div>
          <div class="p-mt-3 p-field p-col-12 p-md-4">
            <span class="p-float-label">
              <Dropdown
                name="qualificationsLevel"
                v-model="formValues.qualificationsLevel"
                :options="qualificationsLevelList"
                v-bind:class="[
                  { 'p-error': errors.has('qualificationsLevel') },
                  'form-control',
                ]"
                :disabled="!inEditing"
                v-validate="'required'"
              />
              <label for="qualificationsLevel">Nível de Qualificações</label>
            </span>
            <small
              v-if="errors.has('qualificationsLevel')"
              class="p-error"
              role="alert"
              >Nível de Qualificações é obrigatório</small
            >
          </div>
          <div class="p-mt-3 p-field p-col-12 p-md-4">
            <span class="p-float-label">
              <InputText
                type="text"
                name="course"
                v-bind:class="[
                  { 'p-error': errors.has('course') },
                  'form-control',
                ]"
                v-model="formValues.course"
                :disabled="!inEditing"
              />
              <label for="course">Curso</label>
            </span>
            <small v-if="errors.has('course')" class="p-error" role="alert"
              >Curso é obrigatório</small
            >
          </div>

          <div class="p-mt-3 p-field p-col-12 p-md-6">
            <FileUpload
              v-if="inEditing"
              ref="uploadInput"
              mode="basic"
              name="formValues.files[]"
              chooseLabel="Adicionar Certificado"
              :multiple="false"
              accept="image/*"
              @select="addFileAbilties"
            />
          </div>
        </div>
        <ImagePreview
          v-if="formValues.url != '' && formValues.url != null"
          :src="formValues.url"
          alt="Image"
          width="250"
          preview
        />
      </form>
      <template #footer>
        <Button
          v-if="inEditing"
          :label="'Guardar'"
          icon="pi pi-save"
          class="p-button-sm p-button-success"
          @click="saveItem"
        />
        <Button
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-sm p-button-danger"
          @click="closeForm"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
export default {
  name: "ProfileLiteraryAbilities",
  props: ["userLiteraryAbilities", "inEditing", "removed"],
  data() {
    return {
      showForm: false,
      formValues: {},
      educationLevelList: [
        "Doutoramento",
        "Mestrado",
        "Licenciatura",
        "Bacharelato",
        "Curso Técnico Superior Profissional",
        "Curso Profissional Técnico",
        "12º Ano",
        "9º Ano",
      ],
      qualificationsLevelList: [
        "Nível 1",
        "Nível 2",
        "Nível 3",
        "Nível 4",
        "Nível 5",
        "Nível 6",
        "Nível 7",
        "Nível 8",
      ],
    };
  },
  created() {},
  methods: {
    addItem() {
      this.formValues = { id: new Date().getTime(), new: true, url: "" };
      this.showForm = true;
    },
    closeForm() {
      this.$validator.pause();
      this.$validator.reset();
      this.showForm = false;
      this.formValues = {};
    },
    editItem(item) {
      this.formValues = { ...item };
      this.formValues.edited = true;
      this.showForm = true;
    },
    removeItem(item) {
      this.$confirm.require({
        header: "Apagar Habilitação Literária",
        message:
          "Tem a certeza que pretende apagar esta habilitação literária?",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sim",
        acceptIcon: "pi pi-check",
        acceptClass: "p-button-success p-button p-component",
        rejectLabel: "Não",
        rejectIcon: "pi pi-times",
        rejectClass: "p-button-danger p-button p-component",
        accept: () => {
          if (!item.new != undefined) {
            this.removed.push({ id: item.id });
          }
          const areYou = (itemAux) => {
            return itemAux.id == item.id;
          };
          let index = this.userLiteraryAbilities.findIndex(areYou);

          if (index >= 0) {
            this.userLiteraryAbilities.splice(index, 1);
          }
        },
        reject: () => {},
      });
    },
    saveItem() {
      this.$validator.resume();
      this.$validator.validateAll().then((isValid) => {
        if (!isValid) {
          return;
        }

        this.$validator.pause();
        this.$validator.reset();

        if (this.$refs.uploadInput.files.length > 0) {
          this.formValues.file = this.$refs.uploadInput.files[0];
        }

        if (this.formValues.edited != undefined) {
          const areYou = (itemAux) => {
            return itemAux.id == this.formValues.id;
          };
          let index = this.userLiteraryAbilities.findIndex(areYou);

          if (index >= 0) {
            this.userLiteraryAbilities[index] = { ...this.formValues };
          }

          return this.closeForm();
        }
        if (this.formValues.new != undefined) {
          this.userLiteraryAbilities.push(this.formValues);
          return this.closeForm();
        }
      });
    },
    addFileAbilties(event) {
      this.formValues.url = event.files[0].objectURL;
    },
  },
};
</script>
<style scoped lang="scss">
.p-datatable-responsive .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}
</style>
